<template>
<div>
    <Breadcrumbs main="Dashboard" title="Manage Beneficiaries" />
    <section id="UsersList" class="container-fluid">
        <div class="row match-height">
            <div class="col-lg-12">
                <div class="card animated fadeIn">
                    <div class="card-content">
                        <div class="card-header dropdown-basic">
                            <a data-toggle="modal" data-target="#addBeneficiaryModalCenter" class="btn btn-primary text-white pull-right"><i class="feather icon-user-plus"></i> &nbsp;Add New</a>
                            <h5>Beneficiary List</h5>
                            <span>Manage all your Beneficiaries. Click the Add Beneficiary button to create a new beneficiary.</span>
                        </div>
                        <div class="card-body">
                          <div class="d-flex">
                            <input type="text" class="form-control col-lg-4" v-model="search" placeholder="Search beneficiary">
                          </div>
                            <div class="table-responsive">
                                <table class="table table-striped" id="BeneficiaryListTable" width="100%">
                                    <thead class="font-weight-bold">
                                        <tr class="text-left">
                                            <th>Account Name</th>
                                            <th>Preferred Name</th>
                                            <th>Account Number</th>
                                            <th>Bank Name</th>
                                            <th>Transaction Type</th>
                                            <th>Biller</th>
                                            <th>Phone Number</th>
                                            <th>Status</th>
                                            <th width="1%"></th>
                                        </tr>
                                    </thead>
                                    <tbody id="BeneficiaryListTableBody">
                                        <tr class="text-left" v-for="beneficiary in filteredList" :key="beneficiary.id">
                                            <td>{{beneficiary.accountName ? beneficiary.accountName : 'N/A'}}</td>
                                            <td>{{beneficiary.preferredName ? beneficiary.preferredName : 'N/A'}}</td>
                                            <td>{{beneficiary.accountNumber ? beneficiary.accountNumber : 'N/A'}}</td>
                                            <td>{{beneficiary.bankName ? beneficiary.bankName : 'N/A'}}</td>
                                            <td>{{beneficiary.transactionType === 2 ? 'Local Transfer' : beneficiary.transactionType === 3 ? 'Inter-bank Transfer' : 'Airtime Purchase'}}</td>
                                            <td>{{beneficiary.biller ? beneficiary.biller : 'N/A'}}</td>
                                            <td>{{beneficiary.phoneNumber ? beneficiary.phoneNumber : 'N/A'}}</td>
                                            <td>{{beneficiary.status === 1 ? 'Active' : 'Inactive'}}</td>
                                            <td class="icon-tag-c" data-toggle="modal" @click="previewEditBeneficiary(beneficiary)" data-target="#beneficiaryEditModal" data-placement="top" title="Edit" ><i class='fa fa-pencil text-warning'></i></td>
                                            <td class="icon-tag-c" data-toggle="modal" @click="deleteBeneficiary(beneficiary.id)" data-target="#beneficiaryDeleteModal" data-placement="top" title="Delete" ><i class='fa fa-trash primary-color'></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="filteredList.length === 0" class="text-center py-3 text-danger">No Beneficiaries Found</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
  <!-- Modal Add New Beneficiary -->
  <div class="modal fade" id="addBeneficiaryModalCenter" tabindex="-1" role="dialog" aria-labelledby="addBeneficiaryCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title pl-2" id="addBeneficiaryCenterTitle" style="font-size: 18px">Add Beneficiary</h5>
                  <button class="close text-dark" @click="resetForm" type="button" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body p-4">
                  <div class="row">
                      <div class="col-md-12">
                          <form @submit.prevent="createBeneficiary">
                              <div class="form-body">
                                  <div class="row">
                                      <div class="col-md-12 col-sm-12">
                                          <div class="mb-3">
                                              <label class="form-label" for="TransactionType">Transaction Type <b class="text-danger">*</b></label>
                                              <select id="TransactionType" v-model="form.transactionType" name="TransactionType" class="form-control form-select" required>
                                                  <option value="" selected disabled>Select Transaction Type</option>
                                                  <option value="2">TAJBank Transfer</option>
                                                  <option value="3">Inter-bank Transfer</option>
                                                  <option value="5">Airtime Purchase</option>
                                              </select>
                                          </div>
                                      </div>
                                      <div v-if="form.transactionType == 2 || form.transactionType == 3" id="account-number-div" class="animated fadeIn col-md-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="FirstName">Account Number <b class="text-danger">*</b></label>
                                              <input class="form-control" @change="getAccountName" v-model="form.accountNumber" @keypress="isNumber" id="AccountNumber" maxlength="10" name="AccountNumber" placeholder="Enter Account Number *" type="text" required/>
                                          </div>
                                      </div>
                                      <div id="bank-name-div" v-if="form.transactionType == 3" class="animated fadeIn col-md-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="BankCode">Bank <b class="text-danger">*</b></label>
                                              <select class="form-control" @change="getBankDetails" v-model="form.bankCode" data-val-length-max="10" required id="BankCode" name="BankCode">
                                                  <option value="">Select Bank *</option>
                                                  <option disabled class="text-danger">Suggested Banks</option>
                                                  <option v-for="suggested in suggestedBanks" :value="suggested.code" :key="suggested.id">{{suggested.name}}</option>
                                                  <option disabled class="text-danger">All Banks</option>
                                                  <option v-for="banks in allBanks" :key="banks.id" :value="banks.code">{{banks.name}}</option>
                                              </select>
                                          </div>
                                      </div>
                                      <div id="account-name-div" v-if="form.transactionType == 2 || form.transactionType == 3" class="animated fadeIn col-md-6">
                                          <div class="mb-3" style="position:relative">
                                              <label class="form-label" for="AccountName">Account Name <b class="text-danger">*</b></label>
                                              <input class="form-control" v-model="form.accountName" id="AccountName" maxlength="250" name="AccountName" placeholder="Enter Account Name *" readonly="readonly" type="text" required />
                                          </div>
                                      </div>
                                      <div id="preferred-name-div" v-if="form.transactionType == 2 || form.transactionType == 3" class="animated fadeIn col-md-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="PreferredName">Preferred Name *</label>
                                              <input v-model="form.preferredName" class="form-control" id="PreferredName" autocomplete="off" @click="removeAutocomplete('preferedName')" name="PreferredName" placeholder="Enter Preferred Name" type="text" required/>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row animated fadeIn" v-if="form.transactionType == 5">
                                      <div id="biller-div" class="col-md-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="Biller">Biller</label>
                                              <select v-model="form.biller" class="form-control acct-num" required><option :value="null" disabled>Select Biller *</option>
                                                <option v-for="biller in airtimeBillers" :value="biller.billerName" :key="biller.billerName">{{biller.billerName}}</option>
                                              </select>
                                              <!-- <input class="form-control" v-model="form.biller" id="Biller" maxlength="250" name="Biller" placeholder="Enter Biller Name" type="text" value="" /> -->
                                          </div>
                                      </div>
                                      <div id="phone-number-div" class="col-md-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="PhoneNumber">Phone Number </label>
                                              <input class="form-control" autocomplete="off" @paste.prevent v-model="form.phoneNumber" maxlength="11" minlength="11" @keypress="isNumber" id="no-paste" placeholder="Enter Phone Number" type="text" required />
                                          </div>
                                      </div>
                                      <div id="preferred-name-div" class="col-md-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="preferred-name">Preferred Name </label>
                                              <input class="form-control" @click="prevReadonly" id="prev-read" autocomplete="off" v-model="form.preferredName" placeholder="Enter Preferred Name" type="text" />
                                          </div>
                                      </div>
                                  </div>
                                  <div class="mb-3 row">
                                      <label class="col-sm-12 col-form-label" for="TransactionPin">Transaction Pin <span class="text-danger">*</span></label>
                                      <div class="col-sm-12 col-xl-12">
                                          <input class="form-control" autocomplete="off" @click="removeAutocomplete('pin')" id="transPin" @paste.prevent v-model="form.transactionPin" @keypress="isNumber" maxlength="4" placeholder="Enter Transaction Pin *" required :type="type" />
                                          <div class="pull-right" @click="showPin"><span class="show">{{type === 'password' ? 'show' : 'hide'}}</span></div>
                                          <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Token" data-valmsg-replace="true"></span>
                                      </div>
                                  </div>
                                  <div class="row">
                                  </div>
                                  <div class="row mt-1">
                                      <div class="col-12">
                                          <button class="btn btn-primary mr-2" type="submit">
                                              <div v-if="loading">
                                                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                              </div>
                                              <div v-else>Submit</div>
                                          </button>
                                          <button @click="resetForm" class="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
                                      </div>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

  <!-- modal to edit beneficiary -->
  <div class="modal fade" id="beneficiaryEditModal" tabindex="-1" role="dialog" aria-labelledby="beneficiaryEditModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pl-2" id="beneficiaryEditModal" style="font-size: 18px">Edit Beneficiary</h5>
                <button class="close text-dark" @click="resetForm" type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-4">
                <div class="row">
                    <div class="col-md-12">
                        <form class="form" @submit.prevent="EditBeneficiaryFunction">
                            <div class="form-body">
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <div class="mb-3">
                                            <label class="form-label" for="TransactionType">Transaction Type <b class="text-danger">*</b></label>
                                            <select id="EditTransactionType" v-model="editBeneficiaryForm.transactionType" name="EditTransactionType" class="form-control form-select" required>
                                                <option value="" selected disabled>Select Transaction Type</option>
                                                <option value="2">TAJBank Transfer</option>
                                                <option value="3">Inter-bank Transfer</option>
                                                <option value="5">Airtime Purchase</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="editBeneficiaryForm.transactionType == 2 || editBeneficiaryForm.transactionType == 3" id="account-number-div" class="animated fadeIn col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="FirstName">Account Number <b class="text-danger">*</b></label>
                                            <input class="form-control" @change="getAccountName" v-model="editBeneficiaryForm.accountNumber" @keypress="isNumber" id="AccountNumber" maxlength="10" name="AccountNumber" placeholder="Enter Account Number *" type="text" required />
                                        </div>
                                    </div>
                                    <div id="bank-name-div" v-if="editBeneficiaryForm.transactionType == 3" class="animated fadeIn col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="BankCode">Bank <b class="text-danger">*</b></label>
                                            <select class="form-control" @change="getBankDetails" v-model="editBeneficiaryForm.bankCode" required id="BankCode" name="BankCode">
                                                <option value="">Select Bank *</option>
                                                <option disabled class="text-danger">Suggested Banks</option>
                                                <option v-for="suggested in suggestedBanks" :value="suggested.code" :key="suggested.id">{{suggested.name}}</option>
                                                <option disabled class="text-danger">All Banks</option>
                                                <option v-for="banks in allBanks" :key="banks.id" :value="banks.code">{{banks.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="editBeneficiaryForm.transactionType == 2 || editBeneficiaryForm.transactionType == 3" class="animated fadeIn col-md-6">
                                        <div class="mb-3" style="position:relative">
                                            <label class="form-label" for="AccountName">Account Name <b class="text-danger">*</b></label>
                                            <input class="form-control" v-model="editBeneficiaryForm.accountName" id="AccountName" maxlength="250" name="AccountName" placeholder="Enter Account Name *" readonly="readonly" type="text" />
                                        </div>
                                    </div>
                                    <div v-if="editBeneficiaryForm.transactionType == 2 || editBeneficiaryForm.transactionType == 3" class="animated fadeIn col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="PreferredName">Preferred Name <b class="text-danger">*</b></label>
                                            <input v-model="editBeneficiaryForm.preferredName" required class="form-control" maxlength="250" name="PreferredName" placeholder="Enter Preferred Name" type="text"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row animated fadeIn" v-if="editBeneficiaryForm.transactionType == 5">
                                    <div id="biller-div" class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="Biller">Biller</label>
                                            <select v-model="editBeneficiaryForm.biller" class="form-control acct-num" required><option :value="null" disabled>Select Biller *</option>
                                              <option v-for="biller in airtimeBillers" :value="biller.billerName" :key="biller.billerName">{{biller.billerName}}</option>
                                            </select>
                                            <!-- <input class="form-control" v-model="editBeneficiaryForm.biller" id="Biller" maxlength="250" name="Biller" placeholder="Enter Biller Name" type="text" value="" /> -->
                                        </div>
                                    </div>
                                    <div id="phone-number-div" class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="PhoneNumber">Phone Number *</label>
                                            <input class="form-control" autocomplete="off" @paste.prevent v-model="editBeneficiaryForm.phoneNumber" minlength="11" maxlength="11" @keypress="isNumber" id="no-paste" required placeholder="Enter Phone Number" type="text" />
                                        </div>
                                    </div>
                                    <div id="preferred-name-div" class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="preferred-name">Preferred Name *</label>
                                            <input class="form-control" @click="prevReadonly" id="prev-read" autocomplete="off" required v-model="editBeneficiaryForm.preferredName" placeholder="Enter Preferred Name" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-12 col-form-label" for="TransactionPin">Transaction Pin <span class="text-danger">*</span></label>
                                    <div class="col-sm-12 col-xl-12">
                                        <input class="form-control" id="new-read" autocomplete="off" @click="NewReadonly" @paste.prevent v-model="editBeneficiaryForm.transactionPin" @keypress="isNumber" minlength="4" maxlength="4" placeholder="Enter Transaction Pin *" required :type="type" />
                                        <div class="pull-right" @click="showPin"><span class="show">{{type === 'password' ? 'show' : 'hide'}}</span></div>
                                    </div>
                                </div>
                                <div class="row">
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12">
                                        <button class="btn btn-warning mr-2" type="submit">
                                            <div v-if="loading">
                                                <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                            </div>
                                            <div v-else>Save Changes</div>
                                        </button>
                                        <button @click="resetForm" class="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

  <!-- Modal Delete Beneficiary -->
  <div class="modal fade" id="beneficiaryDeleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteBeneficiaryCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title pl-2" id="deleteBeneficiaryCenterTitle" style="font-size: 18px">Delete Beneficiary</h5>
                  <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body p-4">
                  <div class="row">
                      <div class="col-md-12">
                          <form class="form" @submit.prevent="confirmDeleteBeneficiary">
                              <div class="form-body">
                                  <p class="text-dark">You are about to delete a beneficiary. Enter Transaction Pin to continue.</p>
                                  <div class="row">
                                      <div class="col-md-12">
                                          <div class="mb-3 row">
                                              <div class="col-sm-12 col-xl-12">
                                                  <input :type="type" required v-model="form.transactionPin" @keypress="isNumber" class="form-control" placeholder="Enter Transaction Pin" minlength="4" maxlength="4">
                                                  <div @click="showPin" class="show-hide"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row mt-1">
                                      <div class="col-12">
                                          <button type="submit" class="btn btn-primary mr-2">
                                              <div v-if="loading">
                                                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                              </div>
                                              <div v-else>Submit</div>
                                          </button>
                                          <button type="reset" data-dismiss="modal" class="btn btn-outline-danger">Cancel</button>
                                      </div>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import $ from 'jquery';
  import { decrypt } from '@/_services/encryption';
  export default {
    data:()=>({
      form: {
        bankCode: '',
        bankName: '',
        accountNumber: '',
        accountName: '',
        preferredName: '',
        biller: null,
        phoneNumber: '',
        platform: 1,
        transactionType: '',
        transactionPin: '',
        BeneficiaryId: ''
      },
      search: '',
      editBeneficiaryForm: {
        bankCode: '',
        bankName: '',
        accountNumber: '',
        accountName: '',
        preferredName: '',
        biller: null,
        phoneNumber: '',
        platform: 1,
        transactionType: '',
        transactionPin: '',
        BeneficiaryId: ''
      },
      type: 'password',
      loading: false,
      suggestedBanks: [],
    }),
    computed: {
      ...mapState({
        beneficiaries: state => state.beneficiaries.beneficiaries,
        allBanks: state => state.beneficiaries.allBanks,
        airtimeBillers: state => state.bills.airtimeBillers,
      }),
      // return all transactions types
      allTransactionTypes() {
        return this.beneficiaries.allTransactionTypes;
      },
      sortedBeneficiaries () {
        const data = [...this.beneficiaries];
        return data.sort((a, b) => {
          return a.accountName.replaceAll(' ', '') < b.accountName.replaceAll(' ', '') ? -1 : a.accountName.replaceAll(' ', '') > b.accountName.replaceAll(' ', '') ? 1 : 0;
        });
      },
      filteredList() {
        return this.sortedBeneficiaries.filter(name => {
          return name.accountName.toLowerCase().includes(this.search.toLowerCase());
        });
      }
    },
    mounted() {
      this.$store.dispatch('beneficiaries/getBeneficiaries');
      this.$store.dispatch('beneficiaries/getAllBanks');
      this.$store.dispatch('bills/getAirtimeBillers');
      // remove auto complete from input
      $('#preferedName').attr('autocomplete', 'off');
    },
    methods: {
      prevReadonly() {
        document.getElementById('prev-read').removeAttribute('readonly');
      },
      removeAutocomplete(value){
        switch (value) {
        case 'preferedName':
          document.getElementById('preferedName').removeAttribute('readonly');
          break;
        case 'pin':
          document.getElementById('transPin').removeAttribute('readonly');
          break;
        }
      },
      NewReadonly () {
        document.getElementById('new-read').removeAttribute('readonly');
      },
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      deleteBeneficiary(val) {
        this.form.BeneficiaryId = val;
      },
      confirmDeleteBeneficiary() {
        const data = {
          id: this.form.BeneficiaryId,
          body: {
            platform: 1,
            transactionPin: this.form.transactionPin,
          },
        };
        this.loading = true;
        this.$store.dispatch('beneficiaries/deleteBeneficiary',  data).then(() => {
          this.loading = false;
          this.$swal({
            title:'Success!',
            text: 'Beneficiary has been deleted.',
            type:'success'
          });
          this.$store.dispatch('beneficiaries/getBeneficiaries');
          $('#beneficiaryDeleteModal').modal('hide');
          this.resetForm();
        }).catch((error) => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
        });
      },
      previewEditBeneficiary(beneficiary) {
        this.editBeneficiaryForm.BeneficiaryId = beneficiary.id;
        this.editBeneficiaryForm.bankCode = beneficiary.bankCode;
        this.editBeneficiaryForm.bankName = beneficiary.bankName;
        this.editBeneficiaryForm.accountNumber = beneficiary.accountNumber;
        this.editBeneficiaryForm.accountName = beneficiary.accountName;
        this.editBeneficiaryForm.preferredName = beneficiary.preferredName;
        this.editBeneficiaryForm.biller = beneficiary.biller;
        this.editBeneficiaryForm.phoneNumber = beneficiary.phoneNumber;
        this.editBeneficiaryForm.transactionType = beneficiary.transactionType;
      },
      EditBeneficiaryFunction() {
        const transactionType = parseInt(this.editBeneficiaryForm.transactionType);
        if(transactionType === 2) {
          this.editBeneficiaryForm.bankCode = '000026';
          this.editBeneficiaryForm.bankName = 'TAJBank';
        }
        const data = {
          id: this.editBeneficiaryForm.BeneficiaryId,
          payload: {
            bankCode: this.editBeneficiaryForm.bankCode,
            bankName: this.editBeneficiaryForm.bankName,
            accountNumber: this.editBeneficiaryForm.accountNumber,
            accountName: this.editBeneficiaryForm.accountName,
            preferredName: this.editBeneficiaryForm.preferredName,
            biller: this.editBeneficiaryForm.biller,
            phoneNumber: this.editBeneficiaryForm.phoneNumber,
            platform: this.editBeneficiaryForm.platform,
            transactionType: parseInt(this.editBeneficiaryForm.transactionType),
            transactionPin: this.editBeneficiaryForm.transactionPin,
          },
        };
        this.loading = true;
        this.$store.dispatch('beneficiaries/editBeneficiary',  data).then(() => {
          this.loading = false;
          this.$swal({
            title:'Success!',
            text: 'Beneficiary Updated Succesfully.',
            type:'success'
          });
          this.editBeneficiaryForm.transactionPin = '';
          this.resetForm();
          this.$store.dispatch('beneficiaries/getBeneficiaries');
          $('#beneficiaryEditModal').modal('hide');
        }).catch((error) => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
        });
      },
      getAccountName(val) {
        const accountNumber = val.target.value;
        this.form.accountName = 'Please wait...';
        this.$store.dispatch('transfers/nameEnquiry', accountNumber).then((response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          this.form.accountName = userParseData.accountName;
          this.editBeneficiaryForm.accountName = userParseData.accountName;
        });
        this.$store.dispatch('transfers/validateAcctNumber', accountNumber ).then((response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          if(response.status === 200) {
            this.suggestedBanks = userParseData.suggestedBankList;
          }
        });
      },
      getBankDetails(event) {
        const bankCode = event.target.value;
        this.allBanks.forEach(bank => {
          if(bank.code === bankCode) {
            this.form.bankName = bank.name;
            this.editBeneficiaryForm.bankName = bank.name;
          }
        });
        const data = {
          bankCode: bankCode,
          accountNumber: this.form.accountNumber ? this.form.accountNumber : this.editBeneficiaryForm.accountNumber,
        };
        this.form.accountName = 'Please wait...';
        this.editBeneficiaryForm.accountName = 'Please wait...';
        this.$store.dispatch('transfers/interbankNameEnquiry', data).then(async (response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          if (response.status === 200) {
            this.form.accountName = userParseData.accountName;
            this.editBeneficiaryForm.accountName = userParseData.accountName;
            this.loading = false;
          }
        }).catch((error) => {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
          this.loading = false;
        });
      },
      createBeneficiary() {
        this.loading = true;
        this.form.transactionType = parseInt(this.form.transactionType);
        var beneficiaryDetails = '';
        if (this.form.transactionType === 2)
          beneficiaryDetails = this.form.accountName;
        else if (this.form.transactionType === 3)
          beneficiaryDetails = `${this.form.accountName} (${this.form.bankName})`;
        else if (this.form.transactionType === 5)
          beneficiaryDetails = `${this.form.phoneNumber} (${this.form.biller})`;
        this.$store.dispatch('beneficiaries/createBeneficiary', this.form).then(async () => {
          this.loading = false;
          this.$store.dispatch('beneficiaries/getBeneficiaries');
          $('#addBeneficiaryModalCenter').modal('hide');
          this.resetForm();
          this.$swal({
            title:'Success',
            text: `Beneficiary ${beneficiaryDetails} created successfully`,
            type:'success',
            confirmButtonText: 'OK'
          });
        }).catch((error) => {
          this.loading = false;
          // this.resetForm();
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
        });
      },
      // rest form fields
      resetForm() {
        this.form.bankCode = '';
        this.form.bankName = '';
        this.form.accountNumber = '';
        this.form.accountName = '';
        this.form.preferredName = '';
        this.form.biller = '';
        this.form.phoneNumber = '';
        this.form.platform = 1;
        this.form.transactionType = '';
        this.form.transactionPin = '';
        this.form.BeneficiaryId = '';
        this.editBeneficiaryForm.transactionPin = '';
      },
    }
  };
</script>
<style>
.show {
    color: #E41613;
    margin-top: 4px;
}
div >>> .submit__btn {
    background-color: #E6E6E6 !important;
}
.loader-box {
    height: 100% !important;
    padding: 8px !important;
}
.table-responsive > .table {
  border: 1px solid #eceeef;
}
.icon-tag-c {
  cursor: pointer;
}
</style>